import { render, staticRenderFns } from "./Paul.vue?vue&type=template&id=75488582"
import script from "./Paul.vue?vue&type=script&lang=js"
export * from "./Paul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports